import { all } from 'redux-saga/effects';

import transactions from './onboardingClient';

function* watch() {
  yield all([transactions.saga.watch()]);
}

export default {
  watch,
};
